import { Buildings, HouseLine } from "@phosphor-icons/react";
import * as React from "react";
import { Dropdown } from "../Dropdown";
import styles from "../Navbar.module.css";

export interface SolutionsDropdownContentProps {
  isSwitching?: boolean;
  isExiting?: boolean;
}

// Companies with Procurement icon - buildings for established companies
const WithProcurementIcon = () => (
  <div className={`${styles.productIcon} ${styles.withProcurementIcon}`}>
    <Buildings size={19} weight="fill" />
  </div>
);

// Companies without Procurement icon - house for smaller organizations
const WithoutProcurementIcon = () => (
  <div className={`${styles.productIcon} ${styles.withoutProcurementIcon}`}>
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <HouseLine size={19} weight="fill" />
    </div>
  </div>
);

export const SolutionsDropdownContent: React.FC<
  SolutionsDropdownContentProps
> = ({ isSwitching, isExiting }) => (
  <Dropdown
    width="wide"
    isSwitching={isSwitching}
    isExiting={isExiting}
    sections={[
      {
        title: "SOLUTIONS",
        layout: "row",
        items: [
          {
            icon: <WithProcurementIcon />,
            title: "Companies with Procurement",
            description:
              "Scale your procurement team's impact with AI-powered agents that handle routine tasks",
            href: "/solutions/companies-with-procurement",
          },
          {
            icon: <WithoutProcurementIcon />,
            title: "Companies without Procurement",
            description:
              "Get enterprise-grade procurement capabilities without building an internal team",
            href: "/solutions/companies-without-procurement",
          },
        ],
      },
    ]}
  />
);
